import './on-confirm.less';
import * as EventUtils from '../../utils/event-utils';
import { bubbleDialogComponentModule } from '../bubble-dialog/bubble-dialog';

export const onConfirmComponentModule = angular
  .module('Q.components.on-confirm', [bubbleDialogComponentModule])

  /**
   * @ngdoc directive
   * @docType shared
   * @category directive
   * @name onConfirm
   * @restrict A
   * @element ANY
   * @description
   * Pops up a bubble dialog window asking the user to confirm before continuing with the action
   * It's like ng-click, but with a confirmation first!
   * @param {expression} onConfirm Action to evaluate on click
   * @param {expression} onConfirmYes If true, always confirm
   * @param {template} onConfirmTitle Optional title
   * @param {template} onConfirmMessage Optional message
   * @param {template} onConfirmYesLabel Override default yes label
   * @param {template} onConfirmYesType Override default yes type (primary)
   * @param {template} onConfirmNoLabel Override default no label
   * @param {template} onConfirmPosition Optional position argument
   *
   * @example
   * <example>
   * <div>
   * <div class="btn btn-default" on-confirm="count = count + 1" ng-init="count=0">Click here to blow up the world!</div>
   * <div> You've blown up the world {{count}} times</div>
   * </div>
   * </example>
   * @returns Directive Definition Object {object}
   */
  .directive('onConfirm', function (bubbleDialogService, $parse) {
    const ACTIVE_CLASS = 'on-confirm-active';
    return {
      restrict: 'A',
      require: ['?^tooltip', '?^dropdown'],
      compile: function ($element, attr) {
        const fn = $parse(attr.onConfirm);

        return function (scope, element, attrs, [tooltipCtrl, dropdownCtrl]) {
          let instance = null;

          const close = () => {
            instance.close();
            instance = null;
            if (tooltipCtrl) tooltipCtrl.setDisabled(false);
            element.removeClass(ACTIVE_CLASS);
          };

          element.on('click', function (event) {
            EventUtils.stopEvent(event);

            if (attrs.disabled) {
              return;
            }

            if (attrs.onConfirmYes && scope.$eval(attrs.onConfirmYes)) {
              scope.$apply(() => {
                if (dropdownCtrl) dropdownCtrl.toggle(false);
                fn(scope, {
                  $event: event,
                });
              });
              return;
            }

            if (instance && !instance.closed) {
              close();
            } else {
              if (tooltipCtrl) tooltipCtrl.setDisabled(true);
              element.addClass(ACTIVE_CLASS);

              const yesTitle = attrs.onConfirmYesLabel || 'Yes';
              const noTitle = attrs.onConfirmNoLabel || 'No';

              instance = bubbleDialogService.open(scope, element, {
                title: attrs.onConfirmTitle,
                content: attrs.onConfirmMessage || 'Are you sure?',
                position: attrs.onConfirmPosition || undefined,
                className: 'on-confirm-dialog',
                buttons: [
                  {
                    title: yesTitle,
                    className: `btn-${attrs.onConfirmYesType || 'primary'} btn-sm`,
                  },
                  {
                    title: noTitle,
                    className: 'btn-default btn-sm',
                  },
                ],
              });

              instance.result
                .then((result) => {
                  if (result === yesTitle) {
                    if (dropdownCtrl) dropdownCtrl.toggle(false);
                    fn(scope, {
                      $event: event,
                    });
                  }
                })
                .finally(close);
            }
          });
        };
      },
    };
  });
